export const ASSESSMENT_HISTORY_REQUEST = "ASSESSMENT_HISTORY_REQUEST";
export const ASSESSMENT_HISTORY_RECEIVE = "ASSESSMENT_HISTORY_RECEIVE";
export const ASSESSMENT_HISTORY_FAILURE = "ASSESSMENT_HISTORY_FAILURE";
export const RESET_ASSESSMENT_HISTORY = "RESET_ASSESSMENT_HISTORY";
